import { Outlet, useOutletContext } from "react-router";

import { Stack } from "@mui/material";
import { BankruptcyChecklistNavigation, ClientTabBase, FormattedText, useBankruptcyChecklistHasWarning } from "@shared";

import { ClientDetailResponse } from "@/api";
import { ClientStatusWidget } from "@/pages/clients/client/components/client-status-widget/ClientStatusWidget";
import { NoticeBanner } from "@/pages/clients/client/components/tabs/debt-settlement-tab/components/notice-banner/NoticeBanner";
import { useTranslation } from "@/translations";

export function BankruptcyChecklist() {
  const client = useOutletContext<ClientDetailResponse>();
  const { t } = useTranslation();
  const hasWarning = useBankruptcyChecklistHasWarning(client.clientId);

  return (
    <Stack gap={2} flex={1} overflow="hidden">
      {hasWarning && (
        <NoticeBanner>
          <FormattedText text={t("clients.client.debtSettlement.bankruptcyChecklist.banner")} />
        </NoticeBanner>
      )}
      <ClientTabBase
        navigation={<BankruptcyChecklistNavigation />}
        navigationFooter={<ClientStatusWidget client={client} />}
      >
        <Outlet context={client} />
      </ClientTabBase>
    </Stack>
  );
}
